import {ThemeProvider} from '@mui/material';
import React, {createContext, useContext} from 'react';
import {AppConfig} from '../AppConfig';
import {DarkThemeCustom} from '../theme/DarkThemeCustom';


const ThemeContext = createContext(null);


const theme = {
    id: 0,
    name: 'dark',
    theme: DarkThemeCustom
  };


const ThemeContextProvider = ({children}) =>
{
  return (
    <>
      <ThemeContext.Provider value={theme}>
        <ThemeProvider theme={AppConfig.defaultTheme}>
          {children}
        </ThemeProvider>
      </ThemeContext.Provider>
    </>
  );
};

ThemeContextProvider.propTypes = {};


const useMBUITheme = () =>
{
  const ctx = useContext(ThemeContext);
  if(ctx == null)
  {
    throw new Error('ThemeContext Provider missing');
  }

  return ctx;
};


export {ThemeContextProvider, useMBUITheme};
